<template>
    <div class="common-canvas">
        <canvas id="xxCanvas" ></canvas>
    </div>
</template>

<script>
import Loader from "@/utils/resourceLoader.js";
import Director from "@/entry/director";
import { DataStore } from "@/entry/base/DataStore.js";
export default {
    props:{
        name:String
    },
    mounted(){
        this.createAnimate();
    },
    methods:{
        createAnimate() {
            let dataStore, director; //总资源
            let isLoader = this.$store.state.isLoader[this.name];
            let length=this.name=='bjx_d'?12:24;
            Loader.create(
                (load, resources, app) => {
                    dataStore = DataStore.getInstance();
                    dataStore[`${this.name}_resources`] = resources;
                    dataStore[`${this.name}_app`] = app;
                    director = new Director(this.name,length,app);
                    director.initScene();
                },
                this.name,
                isLoader,
                {
                    w:750,
                    h:317,
                    el:"xxCanvas"
                }
            );
            this.$store.dispatch("saveLoaderStatus", {
                type: this.name,
                value: true
            });
        }
    }
}
</script>

<style lang="scss" scoped>

</style>